import { TimeSelect } from 'element-ui'
import './style.scss'

const YTimeSelect = TimeSelect
YTimeSelect.$depends = [TimeSelect]
YTimeSelect.$name = 'y-time-select'
YTimeSelect._name = 'TimeSelect 时间选择'

export default YTimeSelect
